
export default {
  nav: {
    home: '首页',
    about: '关于我们',
    products: '产品介绍',
    materials: '新型碳材料',
    solventfree: '无溶剂粘合剂',
    estersolvent: '酯溶剂粘合剂',
    alcoholicsolvent: '醇溶剂粘合剂',
    news: '新闻中心',
    support: '技术支持',
    hr: '人力资源',
    contact: '联系我们',
    more: '更多',
    language: '语言选择'
  },
  menu: {
    loading: '加载中...',
    home: '首页',
    newCarbonMaterials: '新型碳材料',
    adhesive: '粘合剂',
    technicalSupport: '技术支持',
    newsCenter: '新闻中心',
    humanResource: '人力资源',
    aboutUs: '关于我们',
    contactUs: '联系我们'
  },
  header:{
    menu: '菜单',
    language: '语言',
  },
  footer: {
    contactTitle: '联系方式',
    addressTitle: '地址',
    address: '中国浙江省湖州市南太湖新区西凤路688号',
    addressCn: '中国浙江省湖州市南太湖新区西凤路688号'
  },
  languageDialog: {
    title: '选择您的语言',
    current: '当前选择',
    switchSuccess: '语言切换成功',
    description: '我们致力于为全球用户提供多语言支持，让更多人能够便捷地使用我们的服务。',
    contactNote: '如果您需要其他语言支持，请联系我们的客服团队。'
  },
  home: {
    title: '首页',
    banner: {
      title: '全球视野，本地服务',
      subtitle: '国际化团队，为您提供本地化的专业服务',
      heroTitle: '新材料 新技术 新突破',
      heroSubtitle: '专业的化学产品制造商，致力于为客户提供优质的产品和服务',
      viewProducts: '查看产品',
      learnMore: '了解更多'
    },
    about: {
      title: '公司简介',
      content: '　湖州欧美化学有限公司通过持续增加的研发投入，不断开发新型产品来满足客户的需求，其软包装复合用粘合剂拥有酯溶、醇溶、水溶、无溶剂四大类系列产品；以及工程结构粘合剂系列, 产品包括门板胶、覆铁胶、电池封端胶等，受到了市场的广泛好评',
      companyIntro: '湖州欧美化学有限公司是位于美国德克萨斯州休斯敦的 Carbon Material LLC在中国投资的子公司之一。公司位于长三角便捷城市-湖州市，靠近杭州国际机场，南京禄口国际机场和上海浦东国际机场，交通十分便捷。',
      companyPhilosophy: '公司遵循"诚信，精湛，创新"的经营理念，以创新平衡人类对能源和环境的需求为公司发展的愿景，通过深入研发和不断创新的产品和应用技术,推动产业向绿色环保方向不断前进。',
      viewMore: '查看更多',
      viewDetails: '查看详情'
    },
    meta: {
      description: '湖州欧美化学有限公司 - 专业的化学产品制造商，致力于创新平衡人类对能源和环境的需求'
    },
    products: {
      title: '我们的产品',
      product1: {
        name: '无溶剂胶粘剂',
        description: '环保型无溶剂复合胶粘剂，适用于食品包装等多种应用场景'
      },
      product2: {
        name: '酯类溶剂胶粘剂',
        description: '高性能酯类溶剂复合胶粘剂，具有优异的粘接强度'
      },
      product3: {
        name: '工程结构胶',
        description: '专业工程结构用胶粘剂，广泛应用于建筑和工业领域'
      }
    },
    advantages: {
      title: '我们的优势',
      innovation: {
        title: '技术创新',
        description: '持续的研发投入，不断推出创新产品和解决方案'
      },
      quality: {
        title: '品质保证',
        description: '严格的质量管理体系，确保产品的高品质和可靠性'
      },
      environment: {
        title: '环保理念',
        description: '致力于绿色环保，开发可持续发展的化学产品'
      },
      service: {
        title: '专业服务',
        description: '专业的技术团队，为客户提供全方位的技术支持'
      }
    }
  },
  about: {
    title: '关于我们',
    subtitle: '了解我们的历史、使命和价值观',
    introHeader: '公司介绍',
    introTitle: '创新平衡人类对能源和环境的需求',
    companyIntro: '我们公司成立于2005年，是一家专注于高科技产品研发和生产的企业。经过多年的发展，我们已经成为行业内的领先企业，产品远销全球多个国家和地区。',
    vr: {
      panoramicVR: '全景 VR',
      visitUs: '无需到场，只需访问我们',
      slideMouse: '滑动鼠标继续参观'
    },
    meta: {
      description: '了解湖州欧美化学有限公司的历史、使命和价值观，我们致力于化学产品的创新研发'
    },
    teamIntro: '我们拥有一支高素质的研发团队，不断推出创新产品，满足市场需求。我们的生产基地配备了先进的生产设备和完善的质量管理体系，确保产品的高品质和可靠性。',
    philosophy: '我们秉承"创新、品质、诚信、共赢"的企业理念，致力于为客户提供最优质的产品和服务，与合作伙伴共同发展，实现互利共赢。',
    culture: {
      title: '企业文化',
      innovation: {
        title: '创新',
        description: '我们致力于技术创新和产品研发，不断推出满足市场需求的新产品'
      },
      quality: {
        title: '品质',
        description: '严格的质量管理体系，确保每一个产品都达到最高标准'
      },
      integrity: {
        title: '诚信',
        description: '以诚待人，以信立业，建立长期稳定的合作关系'
      },
      philosophy: {
        title: '理念',
        description: '创新平衡人类对能源和环境的需求，推动产业可持续发展'
      }
    },
    timeline: {
      title: '发展历程',
      item1: {
        title: '公司成立',
        description: '公司投资400万美元在湖州成立"湖州欧美化学有限公司"'
      },
      item2: {
        title: '建成投产',
        description: '公司于2005年5月建成投产'
      },
      item3: {
        title: '新产品开发',
        description: '公司开发出新型功能的水处理精细化学品，并不断创新，持续开发环保型、高效性水处理产品'
      },
      item4: {
        title: '产品拓展',
        description: '为适应市场需求，公司研制开发无溶剂聚氨酯粘合剂产品'
      },
      item5: {
        title: '产业升级',
        description: '公司顺应时代潮流，进军新能源，新材料产业，拓展自身的商业模式和经营范围，利用自身化工企业优势，迅速推动新型碳材料的开发'
      },
      item6: {
        title: '溶剂回收',
        description: '公司开拓新的溶剂回收领域，已建成NMP溶剂精制提纯生产线，对NMP溶剂进行回收利用'
      },
      item7: {
        title: '专利成果',
        description: '截止到当年，公司已经获得授权发明专利11项（其中一个美国专利和一个欧洲专利）'
      },
      item8: {
        title: '产能扩大',
        description: '无溶剂粘合剂产品的产能从原先年产能3000吨增至年产能6000吨'
      },
      item9: {
        title: '市场认可',
        description: '新研发的单组份无溶剂粘合剂产品性能和品质稳定性得到市场广泛认可，占据了稳定增长的市场份额'
      },
      item10: {
        title: '产品多样化',
        description: '公司新研发并已投入市场测试使用的PVDC水性底涂胶、医药包装泡罩膜复合粘合剂、耐拉伸耐蒸煮胶、铝合金包覆胶以及木器漆等产品逐渐开始被市场认可'
      },
      item11: {
        title: '研发中心建设',
        description: '公司的新研发中心将开始建造，提前诚邀各路英才加入'
      }
    }
  },
  products: {
    title: '产品介绍',
    meta: {
      description: '湖州欧美化学有限公司产品介绍 - 软包装复合用粘合剂、工程结构粘合剂等专业化学产品'
    },
    viewDetails: '查看详情',
    cancel: '取消',
    jumpToDetails: '跳转到详细页面',
    categories: {
      solventFree: {
        title: '无溶剂胶粘剂系列',
        description: '高性能无溶剂复合胶粘剂，适用于各种包装材料'
      },
      esterSolvent: {
        title: '酯类溶剂型胶粘剂系列',
        description: '专业酯类溶剂复合胶粘剂，具有优异的粘接性能'
      }
    },
    solventFree: {
      product1: {
        application: '广泛应用',
        infoLabel1: 'T.F ON ANSI 31-2024',
        infoValue1: 'PAA 快速衰减',
        descriptions: [
          '芳香族和脂肪族混合异氰酸酯',
          '13°C AL RCPP 固化耐性',
          'PAA 在PootiStaff >0.01 mg/kg 固化后'
        ]
      }
    }
  },
  materials: {
    title: '材料介绍',
    learnMore: '了解更多',
    information: '信息',
    detailModal: {
      description: '产品描述',
      specifications: '规格参数',
      applications: '应用领域',
      features: '特性优势',
      close: '关闭',
      contact: '联系我们'
    },
    material1: {
      category: '碳材料',
      title: '新型',
      description: '碳是自然界中存在的最密切相关和重要的元素之一。同时，由于其特殊的微观结构，由六十元素组成的碳材料具有独特的性质，以及纳米碳相，现在碳材料正在不断被开发和人工制造。',
      placeholder: '新型碳材料'
    },
    material2: {
      title: '碳纳米管',
      description: '碳纳米管是一种形成的纳米材料。其结构特征极其有序。将其添加到混凝土中不能使电池有效导电以保持足够的比热容性能。作为导电方向和锂离子电池第一和液体导电性。',
      placeholder: '碳纳米管结构'
    },
    material3: {
      title: '导电浆料',
      description: '碳传输混合点在生产过程中以团聚的形式与各种结晶浆料和锂离子及其硫化碳成分。作为液体溶剂系统中的碳纳米管之一，含量一般在2-10%之间，粘度适中，为下游应用带来了极大的便利。',
      placeholder: '导电浆料'
    },
    material4: {
      title: '纳米碳纤维',
      description: '碳纳米纤维是一种通过气相沉积法连续生长的纳米纤维，直径为120-200纳米。它具有高导电性、高导电性、高强度、良好的柔韧性和易分散的特点。对于许多导电应用来说是不可缺少的。',
      placeholder: '纳米碳纤维'
    },
    material5: {
      title: '复合多孔石墨材料',
      description: '多孔软碳是一种具有高比表面、孔径和孔体积以及一定石墨结构的合成碳材料，因此是一种具有快速充电和长期性能的特殊锂电池负极材料。通过特殊配方和加工技术，该材料具有高容量（>350 mah/g）和令人满意的首次充放电效率。',
      placeholder: '复合多孔石墨'
    },
    material6: {
      title: '研发中的新产品',
      description: '随着科学技术的发展和人民生活水平的提高，新型碳材料发展迅速，预计将生产越来越多的碳材料产品。',
      placeholder: '研发设备'
    }
  },
  news: {
    title: '新闻中心',
    newsCenter: '企业新闻',
    subtitle: '了解公司最新动态和行业资讯',
    viewAll: '查看全部新闻',
    developing: '显示所有新闻功能开发中',
    releaseTime: '发布时间',
    learnMore: '了解更多',
    emptyHint: '暂无新闻发布，敬请期待。',
    news1: {
      title: '新材料技术突破',
      summary: '我们在碳材料领域取得重大技术突破，新产品将为客户带来更优质的解决方案...'
    },
    news2: {
      title: '绿色环保生产',
      summary: '公司致力于环保生产，采用最新的清洁技术，为可持续发展贡献力量...'
    },
    news3: {
      title: '国际合作项目',
      summary: '与国际知名企业达成战略合作，共同推进新能源材料的研发与应用...'
    },
    news4: {
      title: '研发团队扩大',
      summary: '公司研发团队规模持续扩大，吸引了更多行业专家加入我们的团队...'
    },
    news5: {
      title: '产品质量认证',
      summary: '我们的产品通过了多项国际质量认证，为客户提供更可靠的保障...'
    },
    news6: {
      title: '技术创新奖项',
      summary: '公司荣获行业技术创新奖，彰显了我们在技术研发方面的卓越成就...'
    },
    news7: {
      title: '市场拓展计划',
      summary: '制定了全新的市场拓展计划，将进一步扩大我们的市场影响力...'
    },
    news8: {
      title: '环保认证获得',
      summary: '公司获得多项环保认证，体现了我们对可持续发展的承诺...'
    },
    news9: {
      title: '数字化转型',
      summary: '全面推进数字化转型，提升生产效率和管理水平...'
    },
    news10: {
      title: '智能制造升级',
      summary: '引入最新智能制造技术，实现生产过程的自动化和智能化管理...'
    },
    news11: {
      title: '可持续发展战略',
      summary: '制定并实施可持续发展战略，在保障经济效益的同时承担社会责任...'
    },
    news12: {
      title: '人才培养计划',
      summary: '启动全面人才培养计划，为员工提供更多职业发展机会和技能提升空间...'
    },
    prevPage: '上一页',
    nextPage: '下一页',
    viewingNews: '正在查看新闻'
  },
  support: {
    title: '技术支持',
    download: '下载',
    downloading: '正在下载',
    document: '文档',
    downloadReady: '准备就绪。在生产环境中，这将触发真实的下载。',
    downloadError: '文件暂时不可用，请稍后再试',
    documents: {
      doc1: {
        type: '技术数据表',
        title: 'SF9310A-SF9310B 技术数据表'
      },
      doc2: {
        type: '技术数据表',
        title: 'SF9620A-SF9620B 技术数据表'
      },
      doc3: {
        type: '技术数据表',
        title: 'SF9270A-SF9270B 技术数据表'
      },
      doc4: {
        type: '产品规格',
        title: '碳纳米管产品规格'
      },
      doc5: {
        type: '使用指南',
        title: '导电浆料使用指南'
      },
      doc6: {
        type: '应用指南',
        title: '高温应用指南'
      },
      doc7: {
        type: '安全数据表',
        title: '材料安全数据表'
      },
      doc8: {
        type: '产品目录',
        title: '2024年产品目录'
      },
      doc9: {
        type: '安装手册',
        title: '产品安装手册'
      },
      doc10: {
        type: '认证证书',
        title: 'ISO认证证书'
      }
    }
  },
  hr: {
    title: '人力资源',
    subtitle: '加入我们，共创美好未来',
    description: '我们致力于为优秀人才提供广阔的发展平台和具有竞争力的薪酬待遇，期待与您携手创造更美好的未来',
    joinUs: '请投递简历至邮箱 {email} 联系电话 {phone} 我们的HR将尽快与您取得联系',
    currentOpenings: '招聘职位',
    fields: {
      address: '地址',
      branch: '部门',
      workingYears: '工作年限',
      education: '学历',
      hiring: '招聘人数',
      releaseDate: '发布时间'
    },
    whyJoinUs: '为什么选择我们',
    keyRequirements: '主要要求',
    applyNow: '立即申请',
    expand: '展开更多',
    collapse: '收起',
    fullRequirements: '任职要求',
    responsibilities: '工作职责',
    benefits: '福利待遇',
    contactInfo: '联系方式',
    contactEmail: '邮箱',
    contactPhone: '电话',
    noPositions: '暂无招聘职位',
    thankYou: '感谢您申请',
    position: '职位',
    sendResume: '我们会尽快处理您的申请',
    jobs: {
      seniorEngineer: {
        title: '高级材料工程师',
        address: '中国浙江省湖州市南太湖新区西凤路688号',
        branch: '研发部门',
        workingYears: '3-5年',
        education: '硕士学位',
        hiring: '2人',
        releaseDate: '2025-01-15',
        type: '全职',
        location: '中国湖州',
        experience: '3-5年',
        salary: '¥20K-35K',
        description: '加入我们的研发团队，开发下一代碳材料和储能应用的创新解决方案。',
        requirements: [
          '材料科学、化学工程或相关领域硕士学位',
          '3年以上碳材料或复合材料研发经验',
          '熟练掌握材料表征技术',
          '强大的分析和解决问题的能力',
          '优秀的中英文沟通能力'
        ],
        responsibilities: [
          '负责碳材料产品的研发和改进',
          '设计并执行实验方案，分析实验结果',
          '与跨部门团队合作，推进项目进展',
          '撰写技术报告和专利申请',
          '参与客户技术交流和产品推广'
        ],
        benefits: [
          '具有竞争力的薪酬待遇',
          '五险一金及商业医疗保险',
          '年度健康体检',
          '专业技能培训和发展机会',
          '弹性工作时间和舒适的办公环境'
        ]
      },
      rdScientist: {
        title: '研发科学家',
        address: '中国上海市浦东新区张江高科技园区',
        branch: '研发中心',
        workingYears: '2-4年',
        education: '学士学位',
        hiring: '3人',
        releaseDate: '2025-01-10',
        type: '全职',
        location: '中国上海',
        experience: '2-4年',
        salary: '¥15K-25K',
        description: '参与专注于先进碳纳米材料及其工业应用的创新研究项目。',
        requirements: [
          '化学、材料科学或相关领域学士学位',
          '2年以上纳米材料研究经验',
          '碳材料合成和表征经验',
          '强大的实验室技能和对细节的关注',
          '能够独立工作和团队合作'
        ],
        responsibilities: [
          '开展碳纳米材料的合成与表征研究',
          '优化材料制备工艺参数',
          '进行产品性能测试和数据分析',
          '协助制定研发项目计划',
          '与产业化团队合作推进技术转化'
        ],
        benefits: [
          '有竞争力的基本薪资',
          '完善的社会保险体系',
          '项目奖金和年终奖励',
          '学术交流和培训机会',
          '良好的研发环境和设备'
        ]
      },
      processEngineer: {
        title: '工艺工程师',
        address: '中国浙江省湖州市南太湖新区西凤路688号',
        branch: '生产部门',
        workingYears: '1-3年',
        education: '学士学位',
        hiring: '5人',
        releaseDate: '2025-01-08',
        type: '全职',
        location: '中国湖州',
        experience: '1-3年',
        salary: '¥12K-20K',
        description: '优化生产工艺，确保碳材料产品的质量和效率。',
        requirements: [
          '化学工程或相关领域学士学位',
          '1年以上化工生产经验',
          '了解质量控制和安全规程',
          '强大的分析和解决问题的能力',
          '良好的团队合作精神'
        ],
        responsibilities: [
          '监督和优化碳材料生产工艺流程',
          '进行工艺参数调整和设备维护',
          '执行质量控制程序，确保产品规格',
          '分析生产数据，提出改进建议',
          '参与新工艺的开发和验证'
        ],
        benefits: [
          '稳定的薪资收入',
          '完善的五险一金',
          '技能提升培训机会',
          '工作稳定性保障',
          '良好的工作环境和团队氛围'
        ]
      }
    },
    culture: {
      innovation: {
        title: '创新驱动',
        description: '我们鼓励创新思维，投资前沿技术研发，让您的创意在这里开花结果。'
      },
      growth: {
        title: '职业发展',
        description: '完善的培训体系和晋升通道，助力您的职业成长和个人发展。'
      },
      teamwork: {
        title: '团队合作',
        description: '多元化的国际团队，开放包容的工作环境，共同追求卓越。'
      },
      benefits: {
        title: '福利待遇',
        description: '竞争性薪酬、完善的社保福利、年度体检、团建活动等丰富福利。'
      }
    }
  },
  contact: {
    title: '联系我们',
    titleCard: '联系我们',
    subtitle: '您可以通过以下方式与我们取得联系',
    contactInfo: '联系方式',
    phone: '电话',
    overseasOffice: '海外办事处',
    usOffice: '美国办事处',
    usAddress: '美国德克萨斯州休斯敦',
    usAddressFull: '美国德克萨斯州斯塔福德市西南高速公路12603号210室，德州77477，美国',
    mapLoadError: '地图加载失败，请稍后重试',
    mapAlt: '公司位置地图 - 中国浙江省湖州市南太湖新区西凤路688号',
    companyName: '湖州欧美化学',
    phoneConsultation: '电话咨询',
    phoneHours: '周一至周五 9:00-18:00',
    email: '电子邮件',
    emailNote: '24小时内回复',
    address: '公司地址',
    addressNote: '中国浙江省湖州市南太湖新区',
    onlineSupport: '在线客服',
    onlineSupportNote: '点击开始聊天',
    supportHours: '工作日 9:00-22:00',
    messageConsultation: '留言咨询',
    nameLabel: '* 姓名',
    namePlaceholder: '请输入您的姓名',
    phoneLabel: '电话',
    phonePlaceholder: '请输入您的电话',
    emailLabel: '邮箱',
    emailPlaceholder: '请输入您的邮箱',
    companyLabel: '公司',
    companyPlaceholder: '请输入您的公司',
    messageLabel: '留言内容',
    messagePlaceholder: '请输入您的留言内容',
    submit: '提交',
    reset: '重置',
    companyLocation: '公司位置',
    companyFullName: '湖州欧美化学有限公司',
    postalCode: '邮编',
    loadingMap: '地图加载中...',
    mapNote: '实际项目中可集成百度地图或高德地图API',
    nameRequired: '请输入姓名',
    emailInvalid: '请输入正确的邮箱地址',
    submitSuccess: '您的留言已提交成功，我们将尽快与您联系',
    calling: '正在为您拨打电话 0572-2678666',
    openingEmail: '正在为您打开邮件客户端',
    onlineServiceDeveloping: '在线客服功能开发中，请通过电话或邮件联系我们',
    emailSubject: '咨询',
    emailBody: '您好，我想了解更多信息。'
  },
  language: {
    title: '语言选择',
    subtitle: '选择您偏好的语言',
    description: '我们致力于为全球用户提供多语言支持，让更多人能够便捷地使用我们的服务。',
    contactNote: '如果您需要其他语言支持，请联系我们的客服团队。',
    current: '当前选择',
    switchSuccess: '语言已切换为:',
    chineseSimplified: '简体中文',
    chineseTraditional: '繁體中文',
    english: 'English',
    spanish: 'Español',
    chineseSimplifiedDesc: '中国大陆地区使用的标准中文',
    chineseTraditionalDesc: '台湾地区使用的传统中文',
    englishDesc: '标准美式英语',
    spanishDesc: '标准西班牙语'
  },
  shareModal: {
    title: '分享页面',
    selectPlatform: '选择分享平台',
    copyLink: '复制链接',
    copy: '复制',
    copySuccess: '链接复制成功！',
    wechatTip: '微信分享功能正在开发中，您可以复制链接手动分享',
    shareToFacebook: '分享到Facebook',
    shareToLinkedIn: '分享到LinkedIn'
  },
  newsDetailModal: {
    title: '新闻详情',
    publishTime: '发布时间',
    close: '关闭',
    loadError: '加载新闻详情失败，请稍后重试'
  },
  languageWelcome: {
    title: '初次见面，请选择您的语言',
    subtitle: '我们为您提供多语言支持，请选择您偏好的语言',
    note: '您可以随时在设置中更改语言偏好',
    switchSuccess: '语言已切换为:'
  },
  menuCarousel: {
    home: {
      title: '首页',
      subtitle: '欢迎来到湖州欧美化学',
      description: '专业的化学产品制造商，致力于为客户提供优质的产品和服务',
      viewMore: '了解更多'
    },
    about: {
      title: '关于我们',
      subtitle: '创新平衡人类对能源和环境的需求',
      description: '湖州欧美化学有限公司，专注于高科技产品研发和生产，成为行业内的领先企业',
      viewMore: '查看详情'
    },
    solventFreeProducts: {
      title: '无溶剂粘合剂',
      subtitle: '环保型无溶剂复合胶粘剂',
      description: '高性能无溶剂复合胶粘剂，适用于食品包装等多种应用场景，具有环保、安全、高效的特点',
      viewMore: '查看产品'
    },
    esterSolventProducts: {
      title: '酯溶剂粘合剂',
      subtitle: '高性能酯类溶剂复合胶粘剂',
      description: '专业酯类溶剂复合胶粘剂，具有优异的粘接性能，广泛应用于各种包装材料',
      viewMore: '查看产品'
    },
    alcoholicSolventProducts: {
      title: '醇溶剂粘合剂',
      subtitle: '高性能醇类溶剂复合胶粘剂',
      description: '专业醇类溶剂复合胶粘剂，具有优异的粘接性能，广泛应用于各种包装材料',
      viewMore: '查看产品'
    },
    materials: {
      title: '新型碳材料',
      subtitle: '先进碳材料技术',
      description: '主要包括碳纳米管和浆料、碳纳米纤维、多重石墨基阳极材料、水基粘合剂和n-甲基吡咯烷酮',
      viewMore: '了解更多'
    },
    news: {
      title: '新闻中心',
      subtitle: '了解公司最新动态',
      description: '获取公司最新资讯和行业动态，了解我们在技术创新和市场拓展方面的最新进展',
      viewMore: '查看新闻'
    },
    support: {
      title: '技术支持',
      subtitle: '专业技术文档与支持',
      description: '提供完整的技术数据表、产品规格、使用指南等专业文档，为客户提供全方位的技术支持',
      viewMore: '获取支持'
    },
    hr: {
      title: '人力资源',
      subtitle: '加入我们，共创美好未来',
      description: '我们诚邀各路英才加入我们的团队，提供具有竞争力的薪酬待遇和广阔的发展空间',
      viewMore: '查看职位'
    },
    contact: {
      title: '联系我们',
      subtitle: '随时与我们取得联系',
      description: '我们期待与您的合作，通过多种方式为您提供专业的咨询和服务支持',
      viewMore: '联系方式'
    }
  },
  productsPage: {
    pageTitle: '胶粘剂',
    title: '产品介绍',
    meta: {
      description: '湖州欧美化学有限公司产品介绍 - 软包装复合用粘合剂、工程结构粘合剂等专业化学产品'
    },
    solventFree: {
      title: '无溶剂粘合剂',
      subtitle: '无溶剂粘合剂'
    },
    esterSolvent: {
      title: '酯溶剂粘合剂',
      subtitle: '酯溶剂粘合剂'
    },
    performanceLevel: "性能等级",
    icons: {
      lamination: {
        main: '复合',
        sub: 'LAMINATION'
      },
      boiling: {
        main: '水煮100°C/30min透明',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: '蒸煮',
        sub: 'RETORT'
      },
      specialities: {
        main: '特殊性能',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: '耐化学性能',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: '高性能',
      highSub: 'High Performance',
      medium: '中性能',
      mediumSub: 'Medium Performance', 
      standard: '普通性能',
      standardSub: 'Cost Effective'
    },
    features: {
      chinese: '中文特性',
      english: '英文特性'
    }
  },
  solventFreeProductsPage: {
    pageTitle: '无溶剂粘合剂',
    title: '无溶剂粘合剂-产品介绍',
    meta: {
      description: '湖州欧美化学有限公司产品介绍 - 软包装复合用粘合剂、工程结构粘合剂等专业化学产品'
    },
    solventFree: {
      title: '无溶剂粘合剂',
      subtitle: '综合性软包装复合用首选粘合剂'
    },

    performanceLevel: "性能等级",
    icons: {
      lamination: {
        main: '复合',
        sub: 'LAMINATION'
      },
      boiling: {
        main: '水煮100°C/30min透明',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: '蒸煮',
        sub: 'RETORT'
      },
      specialities: {
        main: '特殊性能',
        sub: 'SPECIALITIES'
      }
    },
    performance: {
      high: '高性能',
      highSub: 'High Performance',
      medium: '中性能',
      mediumSub: 'Medium Performance', 
      standard: '普通性能',
      standardSub: 'Cost Effective'
    },
    features: '特性'
  },
  esterSolventProductsPage: {
    pageTitle: '酯溶剂粘合剂',
    title: '酯溶剂粘合剂-产品介绍',
    meta: {
      description: '湖州欧美化学有限公司产品介绍 - 软包装复合用粘合剂、工程结构粘合剂等专业化学产品'
    },
    esterSolvent: {
      title: '酯溶剂粘合剂',
      subtitle: '综合性软包装复合用首选粘合剂'
    },
    performanceLevel: "性能等级",
    icons: {
      lamination: {
        main: '复合',
        sub: 'LAMINATION'
      },
      boiling: {
        main: '水煮100°C/30min透明',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: '蒸煮',
        sub: 'RETORT'
      },
      specialities: {
        main: '特殊性能',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: '耐化学性能',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: '高性能',
      highSub: 'High Performance',
      medium: '中性能',
      mediumSub: 'Medium Performance', 
      standard: '普通性能',
      standardSub: 'Cost Effective'
    },
    features: '特性'
  },
  alcoholicSolventProductsPage: {
    pageTitle: '醇溶剂粘合剂',
    title: '醇溶剂粘合剂-产品介绍',
    meta: {
      description: '湖州欧美化学有限公司产品介绍 - 软包装复合用粘合剂、工程结构粘合剂等专业化学产品'
    },
    alcoholicSolvent: {
      title: '醇溶剂粘合剂',
      subtitle: '综合性软包装复合用首选粘合剂'
    },
    performanceLevel: "性能等级",
    icons: {
      lamination: {
        main: '复合',
        sub: 'LAMINATION'
      },
      boiling: {
        main: '水煮100°C/30min透明',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: '蒸煮',
        sub: 'RETORT'
      },
      specialities: {
        main: '特殊性能',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: '耐化学性能',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: '高性能',
      highSub: 'High Performance',
      medium: '中性能',
      mediumSub: 'Medium Performance', 
      standard: '普通性能',
      standardSub: 'Cost Effective'
    },
    features: '特性'

  },
  companyName: "湖州欧美化学有限公司"
}